<template>
  <div>
    <div class="search-result">
      <div class="input-wrap">
        <div class="input">
          <a-input-search
            v-model:value="keyword"
            placeholder="请输入要搜索的内容"
            @search="onSearch"
            size="large"
            ><template #enterButton
              ><i class="iconfont icon-sousuo"></i
            ></template>
          </a-input-search>
        </div>
      </div>

      <div class="tabs">
        <keep-alive>
          <a-tabs
            v-model:activeKey="activeKey"
            :animated="false"
            @change="changeTab"
          >
            <a-tab-pane key="1" :tab="'文章（' + totalCount['eNum'] + '）'">
              <div class="list" v-if="totalCount['eNum'] > 0">
                <div
                  class="article-item"
                  v-for="item in articles"
                  :key="item.id"
                >
                  <div class="title">
                    <router-link
                      :to="{ path: '/view/detail', query: { id: item.id } }"
                      target="_blank"
                      v-html="item.title"
                    ></router-link>
                  </div>
                  <div class="pic f-r" v-if="item.imgUrl">
                    <img
                      :src="
                        item.imgUrl.indexOf('https://') !== -1
                          ? item.imgUrl
                          : imgSiteUrl + item.imgUrl
                      "
                      alt=""
                    />
                  </div>
                  <div class="desc descsearch" v-html="item.summary"></div>
                  <div class="user-ctrls user-ctrls-2">
                    <div class="teacher f-l">
                      <span class="dates f-r" v-if="item.pubTime"
                        >&nbsp;&nbsp;<i>·</i>&nbsp;&nbsp;{{
                          item.pubTime.substring(0, 10)
                        }}</span
                      >
                      <div class="teacher-info f-l">
                        <div class="teacher-header" v-if="item.userInfoEntity">
                          <router-link
                            :to="{
                              path: '/user/articles',
                              query: { id: item.userId },
                            }"
                            target="_blank"
                          >
                            <img
                              :src="
                                item.userInfoEntity.imgUrl.indexOf(
                                  'https://'
                                ) !== -1
                                  ? item.userInfoEntity.imgUrl
                                  : imgSiteUrl + item.userInfoEntity.imgUrl
                              "
                              alt=""
                              v-if="item.userInfoEntity.imgUrl"
                            />
                            <img v-else src="~@/assets/img/head1.png" alt="" />
                          </router-link>
                        </div>
                      </div>
                      <div class="teacher-name f-l" v-if="item.userInfoEntity">
                        <router-link
                          :to="{
                            path: '/user/articles',
                            query: { id: item.userId },
                          }"
                          target="_blank"
                          >{{ item.userInfoEntity.userName }}</router-link
                        >
                      </div>
                    </div>
                    <div class="article-attrs f-r">
                      <span class="browseCount"
                        ><i class="iconfont icon-liulan"></i>&nbsp;{{
                          item.browseQua
                        }}&nbsp;</span
                      >
                      <span class="collectCount"
                        ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                          item.collectQua
                        }}&nbsp;</span
                      >
                      <span class="recCount"
                        ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                          item.praiseQua
                        }}&nbsp;</span
                      >
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="empty" v-else>
                <a-empty>
                  <template #description>
                    <span>
                      没有找到和“<span class="blank-keyword">{{ keyword }}</span
                      >”相关的文章
                    </span>
                  </template>
                </a-empty>
              </div>
              <div class="page">
                <a-pagination
                  v-model:current="current1"
                  show-quick-jumper
                  :total="totalCount['eNum']"
                  @change="
                    (e) => {
                      onChangePage(e, 1);
                    }
                  "
                  :hideOnSinglePage="true"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" :tab="'用户（' + totalCount['uNum'] + '）'">
              <div class="list" v-if="totalCount['uNum']">
                <div class="user-item" v-for="item in users" :key="item.id">
                  <div class="btns" v-if="item.id !== loginUserId">
                    <a-button
                      type="primary"
                      ghost
                      v-if="item.followed"
                      @click="setFocus(item)"
                      >已关注</a-button
                    >
                    <a-button
                      type="primary"
                      v-else
                      @click="setFocus(item)"
                      style="width: 74px"
                      >关注</a-button
                    >
                  </div>
                  <div class="pic" v-if="item.imgUrl">
                    <router-link
                      :to="{ path: '/user/articles', query: { id: item.id } }"
                      target="_blank"
                    >
                      <img
                        :src="
                          item.imgUrl.indexOf('https://') !== -1
                            ? item.imgUrl
                            : imgSiteUrl + item.imgUrl
                        "
                        alt=""
                      />
                    </router-link>
                  </div>
                  <div class="pic" v-else>
                    <router-link
                      :to="{ path: '/user/articles', query: { id: item.id } }"
                      target="_blank"
                    >
                      <img src="~@/assets/img/head1.png" alt="" />
                    </router-link>
                  </div>
                  <router-link
                    :to="{ path: '/user/articles', query: { id: item.id } }"
                    target="_blank"
                    class="username"
                    v-html="item.username"
                  ></router-link>
                  <div
                    class="personalProfile"
                    v-html="item.personalProfile"
                  ></div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="empty" v-else>
                <a-empty>
                  <template #description>
                    <span>
                      没有找到和“<span class="blank-keyword">{{ keyword }}</span
                      >”相关的用户
                    </span>
                  </template>
                </a-empty>
              </div>
              <div class="page">
                <a-pagination
                  v-model:current="current2"
                  show-quick-jumper
                  :total="totalCount['uNum']"
                  @change="
                    (e) => {
                      onChangePage(e, 2);
                    }
                  "
                  :hideOnSinglePage="true"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" :tab="'论文（' + totalCount['aNum'] + '）'">
              <div class="list" v-if="totalCount['aNum'] > 0">
                <div class="essay-item" v-for="item in essays" :key="item.id">
                  <!-- <div class="title">
                                    <router-link :to="{path:'/essay/detail',query:{id:item.id,type:1}}" target="_blank" v-html="item.title"></router-link>
                                </div> -->
                  <div class="title">
                    <router-link
                      :to="{
                        path: '/essay_detail',
                        query: { id: item.id, type: 1 },
                      }"
                      target="_blank"
                      v-html="item.title"
                    ></router-link>
                  </div>
                  <div class="author">
                    <span
                      v-html="item.authors ? item.authors.join(' ') : ''"
                    ></span>
                    -《<span v-html="item.journalNameZH"></span>》 -
                    {{ item.pubYear }}年{{ item.period }}期
                  </div>
                  <div class="summary" v-html="item.summary"></div>
                  <div class="keywords">
                    <div class="count" style="color: #aaa">
                      <span class="browseCount"
                        ><i class="iconfont icon-liulan"></i>&nbsp;{{
                          item.browseQua
                        }}&nbsp;</span
                      >
                      <span class="collectCount"
                        ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                          item.collectQua
                        }}&nbsp;</span
                      >
                      <span class="recCount"
                        ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                          item.praiseQua
                        }}&nbsp;</span
                      >
                    </div>

                    <a-tag v-for="i in item.topicList" :key="i.topicId">
                      {{ i .topicName}}
                    </a-tag>
                    <div class="clearx"></div>
                  </div>
                </div>
              </div>
              <div class="empty" v-else>
                <a-empty>
                  <template #description>
                    <span>
                      没有找到和“<span class="blank-keyword">{{ keyword }}</span
                      >”相关的论文
                    </span>
                  </template>
                </a-empty>
              </div>
              <div class="page">
                <a-pagination
                  v-model:current="current3"
                  show-quick-jumper
                  :total="totalCount['aNum']"
                  @change="
                    (e) => {
                      onChangePage(e, 3);
                    }
                  "
                  :hideOnSinglePage="true"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane key="4" :tab="'论文集（' + totalCount['gNum'] + '）'">
              <div class="list" v-if="totalCount['gNum'] > 0">
                <div
                  class="essay-item"
                  v-for="item in collections"
                  :key="item.id"
                >
                  <div class="title">
                    <router-link
                      :to="{
                        path: '/collection_detail',
                        query: { id: item.id },
                      }"
                      target="_blank"
                      v-html="item.name"
                    ></router-link>
                  </div>
                  <div class="summary" v-html="item.summary"></div>
                  <div class="author">
                    <div class="teacher-info f-l">
                      <div class="teacher-header" v-if="item.userInfoEntity">
                        <router-link
                          :to="{
                            path: '/user/articles',
                            query: { id: item.userId },
                          }"
                          target="_blank"
                        >
                          <img
                            :src="
                              item.userInfoEntity.imgUrl &&
                              item.userInfoEntity.imgUrl.indexOf('https://') !==
                                -1
                                ? item.userInfoEntity.imgUrl
                                : imgSiteUrl + item.userInfoEntity.imgUrl
                            "
                            alt=""
                            v-if="item.userInfoEntity.imgUrl"
                          />
                          <img v-else src="~@/assets/img/head1.png" alt="" />
                        </router-link>
                      </div>
                    </div>
                    <div class="teacher-name f-l" v-if="item.userInfoEntity">
                      <router-link
                        :to="{
                          path: '/user/articles',
                          query: { id: item.userId },
                        }"
                        target="_blank"
                        >{{ item.userInfoEntity.userName }}</router-link
                      >
                    </div>

                    <div class="count f-r" style="color: #666">
                      {{ thousandSplit(item.collectQua) }}人收藏
                      <a-divider type="vertical" />
                      {{ thousandSplit(item.articleQua) }}篇论文
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
              <div class="empty" v-else>
                <a-empty>
                  <template #description>
                    <span>
                      没有找到和“<span class="blank-keyword">{{ keyword }}</span
                      >”相关的论文集
                    </span>
                  </template>
                </a-empty>
              </div>
              <div class="page">
                <a-pagination
                  v-model:current="current4"
                  show-quick-jumper
                  :total="totalCount['gNum']"
                  @change="
                    (e) => {
                      onChangePage(e, 4);
                    }
                  "
                  :hideOnSinglePage="true"
                />
              </div>
            </a-tab-pane>
          </a-tabs>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import config from "@/until/configs";
import Http from "@/until/http";
import {
  confirmLogin,
  getCookie,
  messageTips,
  thousandSplit,
} from "@/until/tools";
import { getLocalItem } from "../../until/tools";

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const keywords = computed(() => {
      return route.query.keyword;
    });
    const sid = computed(() => {
      return getCookie("z_sid");
    });

    const loginUserId = computed(() => {
      let sid = getCookie("z_sid");
      if (sid) {
        return getLocalItem("userInfo").userId;
      } else {
        return null;
      }
    });
    const state = reactive({
      keyword: "",
      activeKey: "1",
      imgSiteUrl: config.imgSiteUrl,
      totalCount: {
        eNum: 0,
        uNum: 0,
        aNum: 0,
        gNum: 0,
      },
      current1: 1,
      current2: 1,
      current3: 1,
      current4: 1,
      articles: [],
      users: [],
      essays: [],
      collections: [],
    });

    const onSearch = () => {
      if (state.keyword === "") {
        return false;
      }
      goSearch(state.keyword);
    };

    const goSearch = (keyword) => {
      router.push({ path: "/totalCount", query: { keyword } });
    };

    watch(keywords, (value) => {
      Object.assign(state, {
        keyword: value,
        current1: 1,
        current2: 1,
        current3: 1,
        current4: 1,
        articles: [],
        users: [],
        essays: [],
        collections: [],
        activeKey: "1",
        totalCount: {
          eNum: 0,
          uNum: 0,
          aNum: 0,
          gNum: 0,
        },
      });
      getTotalCount();
      searchArticle();
    });

    const onChangePage = (e, type) => {
      if (type === 1) {
        searchArticle(e);
      } else if (type === 2) {
        searchUser(e);
      } else if (type === 3) {
        searchEssay(e);
      } else if (type === 4) {
        searchCollections(e);
      }
    };

    const getTotalCount = () => {
      Http.totalCount({ keyword: state.keyword }).then((res) => {
        if (res) {
          Object.assign(state, {
            totalCount: res,
          });
        }
      });
    };

    const searchArticle = (pageNum = 1) => {
      Http.searchArticle({ keyword: state.keyword, pageNum }).then((res) => {
        if (res) {
          if (res.essays) {
            Object.assign(state, {
              articles: res.essays,
              current1: pageNum,
            });
            window.scrollTo(0, 0);
          }
        }
      });
    };

    const searchUser = (pageNum = 1) => {
      Http.searchUser({ keyword: state.keyword, pageNum }).then((res) => {
        if (res) {
          if (res.pmsUsers) {
            Object.assign(state, {
              users: res.pmsUsers,
              current2: pageNum,
            });
            window.scrollTo(0, 0);
          }
        }
      });
    };

    const searchEssay = (pageNum = 1) => {
      Http.getEssayRec({ keyword: state.keyword, pageNum }).then((res) => {
        if (res) {
          if (res.articles) {
            Object.assign(state, {
              essays: res.articles,
              current3: pageNum,
            });
            window.scrollTo(0, 0);
          }
        }
      });
    };

    const searchCollections = (pageNum = 1) => {
      Http.getEssayCollections({ keyword: state.keyword, pageNum }).then(
        (res) => {
          if (res) {
            if (res.aggItems) {
              Object.assign(state, {
                collections: res.aggItems,
                current4: pageNum,
              });
              window.scrollTo(0, 0);
            }
          }
        }
      );
    };

    const changeTab = (key) => {
      if (key === "1") {
        if (state.current1 !== 1) {
          searchArticle();
        } else {
          if (state.articles.length === 0) {
            searchArticle();
          }
        }
      } else if (key === "2") {
        if (state.current2 !== 1) {
          searchUser();
        } else {
          if (state.users.length === 0) {
            searchUser();
          }
        }
      } else if (key === "3") {
        if (state.current3 !== 1) {
          searchEssay();
        } else {
          if (state.essays.length === 0) {
            searchEssay();
          }
        }
      } else if (key === "4") {
        if (state.current4 !== 1) {
          searchCollections();
        } else {
          if (state.collections.length === 0) {
            searchCollections();
          }
        }
      }
    };

    const setFocus = (item) => {
      if (!sid.value) {
        confirmLogin();
        return false;
      }
      let params = {
        resId: item.id,
        flag: item.followed ? 1 : 0,
      };
      Http.foucsAuthor(params).then((res) => {
        if (res) {
          if (res.success) {
            item.followed = params.flag ? 0 : 1;
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    };

    onMounted(() => {
      Object.assign(state, { keyword: route.query.keyword });
      document.title = "搜索“" + state.keyword + "”-" + config.siteTitle;
      searchArticle();
      getTotalCount();
    });

    return {
      ...toRefs(state),
      onSearch,
      onChangePage,
      changeTab,
      setFocus,
      thousandSplit,
      loginUserId,
    };
  },
});
</script>
<style lang="scss">
@import "@/scss/_variables.scss";
.ant-empty-description {
  font-size: 16px;
  .blank-keyword {
    font-size: 18px;
    color: $primary-color;
    font-weight: bold;
  }
}
</style>
<style lang="scss" scoped>
@import "../../scss/search.scss";
.ant-tag {
  background: #fff;
}
.descsearch {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
<style lang="scss" scoped>
.input {
  /deep/.ant-btn-primary {
    border-left: none !important;
    color: #aaa !important;
    background: #fff !important;
    border-color: #ccc !important;
  }
}
</style>